const businessInformationQuestions = {
  1: {
    // Business Details
    trading_name: "",
    company_registration_number: "",
    num_years_operating: 0,
    industry: "",
    financial_year_ends: '',
    website_url: "",
    goods_and_services: "",
    has_bank_account: '',
    has_tax_number: '',
    has_vat_number: '',
    has_BBBEE_certificate: '',
    // Additional Details
    location: '',
    contact_number: '',
    has_facebook: false,
    has_twitter: false,
    has_instagram: false,
    has_linkedin: false,
    has_whatsapp: false,
    // facebook_url: '',
    // twitter_url: '',
    // instagram_url: '',
    // linkedin_url: '',
    // contact_phone_number: '',
    // whatsapp_number: '',
  },
  2: {
    tax_number: '',
    tax_certificate: '',
    vat_number: '',
    BBBEE_level: '',
    BBBEE_certificate: '',
    bank_name: '',
    additional_banks: '',
  }
};

const financeQuestions = {
  1: {
    has_record_keeping_system: false,
    record_keeping_system_type: '',
    has_updated_financials: false,
    has_accountant: false,
    has_audited_financials: false,
    has_monthly_budget: false,
    uses_accounting_software: false,
  },
  2: {
    record_keeping_proof: {},
    updated_financials_proof: {},
    monthly_budget_proof: {},
    accountant_proof: {},
  }
};

const staffingQuestions = {
  1: {
    has_staff: false,
    num_staff_employed: '',
    has_employee_contracts: false,
    has_job_descriptions: false,
    has_hr_policy: false,
    has_payroll_system: false,
    payroll_system: '',
  },
  2: {
    employee_contracts_proof: {},
    job_descriptions_proof: {},
    hr_policy_proof: {},
  }
};

const marketingQuestions = {
  1: {
    has_mission_statement: false,
    has_marketing_plan: false,
    has_roi_strategy: false,
    has_client_satisfaction_procedure: false,
    has_social_media_strategy: false,
    has_logo: false,
    has_client_relationship_program: false,
    has_sales_targets: false,
  },
  2: {
    mission_statement: '',
    marketing_plan_proof: {},
    roi_strategy_proof: {},
    client_satisfaction_procedure_proof: {},
    social_media_strategy_proof: {},
    logo_proof: {},
    client_relationship_program_proof: {},
    sales_targets_proof: {},
  },
};

const ITQuestions = {
  1: {
    has_asset_register: false,
    has_IT_policy: false,
    has_data_policy: false,
    has_privacy_policy: false,
    IT_staff_management_type: ''
  },
  2: {
    IT_policy_proof: {},
    privacy_policy_proof: {},
    is_POPI_act_compliant: false,
    POPI_act_compliant_proof: {},
    has_data_storage_procedure: false,
    data_storage_procedure_proof: {},
    has_purchasing_procedure: false,
    purchasing_procedure_proof: {},
  }
};


const operationalQuestions = {
  1: {
    has_score_card: false,
    has_quality_plan: false,
    has_standard_operating_procedures: false,
    has_non_compliant_products: false,
    has_corrective_action_plan: false,
    has_preferential_suppliers: false,
    has_equipment_register: false,
  },
  2: {
    score_card_proof: {},
    quality_plan_proof: {},
    standard_operating_procedures_proof: {},
    non_compliant_products_proof: {},
    corrective_action_plan_proof: {},
    preferential_suppliers_proof: {},
    equipment_register_proof: {},
  }
};

export { 
  businessInformationQuestions,
  financeQuestions,
  staffingQuestions,
  marketingQuestions,
  ITQuestions,
  operationalQuestions,
};
